import React, { useState } from 'react';
import {AddRounded, RemoveRounded} from "@mui/icons-material";

function computeYearlyReturns(seriesData) {
  const yearlyReturns = seriesData.map(series => {
    const yearlyData = {};
    series.data.forEach(entry => {
      const year = entry.timestamp.split('-')[0];
      if (!yearlyData[year]) {
        yearlyData[year] = {
          startValue: entry.close,
          endValue: entry.close
        };
      } else {
        yearlyData[year].endValue = entry.close;
      }
    });

    const returns = Object.keys(yearlyData).map(year => ({
      year,
      return: ((yearlyData[year].endValue - yearlyData[year].startValue) / yearlyData[year].startValue) * 100
    }));

    return {
      name: series.name,
      data: returns
    };
  });

  // Calculate differences between the first and second series
  const differences = yearlyReturns[0].data.map((data, index) => {
    return {
      year: data.year,
      difference: data.return - yearlyReturns[1].data[index].return
    };
  });

  return { returns: yearlyReturns, differences };
}



const YearlyReturnsTable = ({ seriesData }) => {
  const [data, setData] = useState(computeYearlyReturns(seriesData));
  const { returns, differences } = data;

  return (
    <table className={'bordered space-cells'}>
      <thead>
        <tr>
          <th>Total Return %</th>
          {returns.length > 0 && returns[0].data.map(r => <th style={{textAlign: 'center'}} key={r.year}>{r.year}</th>)}
        </tr>
      </thead>
      <tbody>
        {returns.map((series, seriesIndex) => (
          <tr key={series.name}>
            <td>{series.name}</td>
            {series.data.map((yearData, index) => (
              <td key={yearData.year} style={{
                textAlign: 'center',
                backgroundColor: returns[0].data[index].return > returns[1].data[index].return
                  ? (seriesIndex === 0 ? '#CDFFEA' : null)
                  : (seriesIndex === 1 ? '#CDFFEA' : null)
              }}>
                {yearData.return.toFixed(2)}%
              </td>
            ))}
          </tr>
        ))}
        <tr>
          <td>Delta +/-</td>
          {differences.map(diff => (
            <td key={diff.year}
                style={{
                  color: `${diff.difference>0?'green':'red'}`,
                  textAlign: 'center'
                }}
            >
                {diff.difference > 0 ? '+' : ''} {diff.difference.toFixed(2)}%
            </td>
          ))}
        </tr>
      </tbody>
    </table>
  );
};

export default YearlyReturnsTable;
